import { Dtos, SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { financialPeriodsQueryKey } from "../../financials";

export function useAdminUpdateBLOCSize(accountId: SuretyAccountId) {
	const { patch } = useRequest();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: async ({
			data,
		}: {
			data: Dtos.Admin.FinancialPeriod.Update.AccountBlocSize.Request;
			onSuccess?: () => void;
			onError?: () => void;
		}) =>
			patch<Dtos.Admin.FinancialPeriod.Get.Response>(
				`/v2/admin/surety/accounts/${accountId}/financial-periods/bloc-size`,
				data,
			),
		onSuccess: (_, { onSuccess }) => {
			queryClient.invalidateQueries({
				queryKey: financialPeriodsQueryKey(accountId),
			});

			onSuccess?.();
		},
		onError: (_, { onError }) => {
			onError?.();
		},
	});

	return {
		updateBLOCSize: mutation.mutate,
		updateBLOCSizeLoading: mutation.isPending,
		updateBLOCSizeError: mutation.error,
		dismissUpdateBLOCSizeError: () => {
			mutation.reset();
		},
	};
}
